import {Component, EventEmitter, Input, Output} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-vertical-nav',
    templateUrl: './vertical-nav.component.html',
    styleUrls: ['./vertical-nav.component.scss'],
    imports: [NgClass]
})
export class VerticalNavComponent {
  @Input() links: {name: string, icon?: string, tag: string}[] = [];
  @Input() activeLink?: string;
  @Output() activeLinkChange = new EventEmitter<string>(); // for two-way binding

  setActive(link: string) {
    this.activeLinkChange.emit(link);
  }
}
